<template>
  <div class="outer-wrapper">
    <div class="inner-page animate__animated animate__slideInRight">
      <b-container fluid>
        <div class="card card-details">
          <div class="card-body p-3">
            <div class="row">
              <div class="col-8 pr-0">
                <h3 class="broker-name">{{ meeting.name }}</h3>
                <span class="firm-name">{{ meeting.firm_name }}</span>
              </div>
              <div class="col-4 pl-0 text-right">
                <a class="label-call" :href="`tel:${meeting.lead_phone}`">
                  <img src="@/assets/phone.svg" width="14" class="mr-2" alt="..." /></a>
              </div>
            </div>
            <div class="row">
              <div class="col-8 pr-0">
                <ul class="list-unstyled mt-1 mb-0">
                  <li class="media mb-1">
                    <img src="@/assets/phone.svg" width="14" class="mr-2" alt="..." />
                    <div class="media-body">
                      <a class="mt-0 mb-1" :href="`tel:${meeting.lead_phone}`">{{ meeting.lead_phone }}</a>
                    </div>
                  </li>
                  <li class="media mb-1" v-if="meeting.lead_email">
                    <img src="@/assets/email.svg" width="14" class="mr-2" alt="..." />
                    <div class="media-body">
                      <a class="mt-0 mb-1 " :href="`mailto:${meeting.lead_email}`">{{ meeting.lead_email }}</a>
                    </div>
                  </li>
                  <li class="media mb-1 addressFeild" v-if="meeting.lead_locality || meeting.lead_address">
                    <img src="@/assets/mappin.svg" width="14" class="mr-2" alt="..." />
                    <div class="media-body">
                      <p class="mt-0 mb-1">{{meeting.lead_locality}}</p>
                      <p class="m-0">{{meeting.lead_address}}</p>
                    </div>
                  </li>
                </ul>
              </div>
              <div class="col-4 pl-0 text-right">
                <span class="label-status"> {{ meeting.lead_status_name }} </span>
              </div>
              <div class="col-4 pl-0">
                <span class="d-block text-link mt-2 ml-4">
                  <router-link :to="{ name: 'editMeeting', params: { uuid: meeting.uuid } }" tag="div" class="text-link m-0">
                    Update
                  </router-link>
                </span>
              </div>
            </div>
          </div>
        </div>
        <div class="card">
          <div class="card-header">
            <div class="row">
              <div class="col-4">
                <h2 class="mt-1">Details</h2>
              </div>
            </div>
          </div>
          <div class="card-body p-3">
            <div class="meetingDate meeting-content">
              <span class="meeting-title ">
                Meeting Date
              </span>
              {{ meeting.meeting_date }}
            </div>
            <div class="meeting-content image-section">
              <span class="meeting-title ">
                Images
              </span>
              <div class="image-list">
                <div v-if="meeting.meeting_attachment_exist" :style="{backgroundImage:'linear-gradient(0deg, rgba(0, 0, 0, 0.4), rgba(0, 0, 0, 0.4)), url('+meeting.meeting_attachment_url+')'}" alt="Attachment" class="meeting-image"><span class="view-image" @click="viewImage(meeting.meeting_attachment_url)">View</span></div>
                <div v-if="meeting.executive_image_url" :style="{backgroundImage:'linear-gradient(0deg, rgba(0, 0, 0, 0.4), rgba(0, 0, 0, 0.4)), url('+meeting.executive_image_url+')'}" alt="Attachment" class="meeting-image"><span class="view-image" @click="viewImage(meeting.executive_image_url)">View Selfie</span></div>
              </div>
            </div>
            <div class="meeting-content">
              <span class="meeting-title ">
                Location
              </span>
              {{ meeting.location }}
            </div>
            <div class="meeting-content" v-if="meeting.comment">
              <span class="meeting-title ">
                Comment
              </span>
              {{ meeting.comment === "null" ? '---' : meeting.comment}}
            </div>
            <div class="meeting-content" v-if="meeting.recorded_audio_url">
              <span class="meeting-title ">
                Recorded Audio
              </span>
              <button type="button" class="btn-view-recording" @click="view_audio(meeting.recorded_audio_url)"">
                <span class="icon-xs play-caret-icon"></span> <span>View</span>
              </button>
            </div>
          </div>
        </div>
      </b-container>
      <router-view></router-view>
    </div>
    <div>
      <b-modal id="view-image-full" modal-class="view-image-full" centered hide-footer hide-header>
        <div class="w-full d-flex justify-content-end">
          <img src="@/assets/close-icon.svg" width="25" height="25" class="view-image-close-icon" @click="hideImageModal()" />
        </div>
        <img :src="viewedImage" class="img-fluid fullscreen-image" />
      </b-modal>
      <b-modal id="add-details" centered hide-header>
        <h2 class="title mb-3">Update Details</h2>
        <textarea name="" id="" cols="30" rows="10" class="form-control border rounded-sm"></textarea>
        <template #modal-footer="{ cancel }">
          <div class="row w-100">
            <div class="col-6">
              <span class="info">
                {{ file2 ? file2.name : "Add photo" }}
                <img src="@/assets/delete-icon.svg" alt="" style="opacity: 0.3" class="ml-1" /></span>
              <b-form-file type="file" id="file" v-model="file2" />
            </div>
            <div class="col-6 text-right">
              <b-button size="sm" variant="outline-default" @click="cancel()">
                Cancel
              </b-button>
              <b-button size="sm" variant="outline-default outline-default-primary" @click="meetingStatus = true">
                <span @click="cancel()">Update</span>
              </b-button>
            </div>
          </div>
        </template>
      </b-modal>
    </div>
  </div>
</template>
<script>
export default {
  name: "MeetingDetails",
  data() {
    return {
      meeting: {},
      viewedImage: null
    };
  },
  created() {
    this.fetchMeetingDetail();
  },
  methods: {
    view_audio(audio) {
      window.open(audio);
    },
    fetchMeetingDetail() {
      let uuid = this.$route.params.id;
      this.$axios.get(`meetings/${uuid}`).then((res) => {
        this.meeting = res.data.meeting;
      });
    },
    viewImage(image) {
      this.viewedImage = image;
      this.$nextTick(() => this.$bvModal.show('view-image-full'));
    },
    hideImageModal() {
      this.$bvModal.hide('view-image-full');
      this.viewedImage = null;
    }
  },
};
</script>
<style scoped>

.btn-view-recording{
  border-radius: 30px;
  padding: 4px 10px 4px 6px;
  border: 1px solid #f58322;
  background-color: rgba(255, 255, 255, 1);
  display: flex;
  align-items: center;
  gap: 4px;
  color: #f58322;
  font-size: 12px;
  font-weight: 400;
  line-height: 1;
  margin-top: 8px;
}
.card-details .broker-name {
  font-size: 16px;
}

.card-details .firm-name {
  font-size: 14px;
}

.label-status {
  border-radius: 18px;
  background: #f2f2f2;
  font-weight: bold;
  font-size: 12px;
  text-align: center;
  letter-spacing: 0.02em;
  padding: 5px 15px;
  display: inline-flex;
  align-content: flex-end;
}

.card-details ul li img {
  margin: 3px 0 0;
}

.card-details ul li p {
  letter-spacing: 0.02em;
  color: #333333;
  opacity: 0.5;
  font-size: 14px;
}

.meeting-title {
  display: block;
  color: #444B4E66;
  margin-bottom: 4px;
}

.meeting-content {
  font-weight: 500;
  font-size: 14px;
  line-height: 17px;
  color: #444B4E;
  margin-bottom: 16px;
}

.image-section .image-list {
  display: flex;
  margin-bottom: 16px;
}

.image-section .image-list .meeting-image {
  width: 106px;
  padding-top: 106px;
  border-radius: 6px;
  position: relative;
  background-repeat: no-repeat;
  background-size: cover;
  background-position: center;
}

.image-section .image-list .meeting-image:not(:first-child) {
  margin-left: 15px;
}

.image-section .image-list .view-image {
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  text-align: center;
  width: 100%;
  top: 40%;
  z-index: 50;
  letter-spacing: 0.1px;
  color: #FFFFFF;
  text-shadow: 0px 1px 1px rgba(0, 0, 0, 0.4);
  font-size: 14px;
  font-weight: 500;
}

.fullscreen-image {
  max-height: 100%;
  max-width: 100%;
  width: auto;
  height: auto;
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  margin: auto;
  border-radius: 1px;
}

.view-image-close-icon {
  margin-top: 4px;
  margin-right: 4px;
  margin-bottom: 20px;
  z-index: 50;
}
</style>